module.exports = __webpack_public_path__ + "img/tool1.d27e3f67.png";